import { isLinkFrodor } from '../lib/isLinkFrodor';
import getRelativePath from './getRelativePath';
export default function adjustLinkHref(href, isFrodor, openInNewWindow) {
    let useInternalNavigation = false;
    let adjustedHref = href;
    if (isFrodor && !openInNewWindow) {
        if (href.startsWith('/')) {
            useInternalNavigation = true;
        }
        else {
            useInternalNavigation = isLinkFrodor(href);
            if (useInternalNavigation) {
                adjustedHref = getRelativePath(href);
            }
        }
    }
    return {
        adjustedHref,
        useInternalNavigation,
    };
}
//# sourceMappingURL=adjustLinkHref.js.map